import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    placeholder: "Masukin nama kamu...",
    name: "username",
    required: ""
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button primary"
}, "Okay, Lanjut", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { computed, onBeforeMount, onMounted, provide, ref } from 'vue';
import { getTemplateMessages } from './services/supabase.service';
import store from './store';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loading = ref<boolean>(false);
provide('isLoading', loading);

onBeforeMount(async () => {
  loading.value = true;
  const { data } = await getTemplateMessages();
  store.commit('SAVE_MESSAGES', data ?? {});
  loading.value = false;
});

onMounted(() =>
  store.commit('UPDATE_CART', JSON.parse(localStorage.getItem('cart') ?? '[]')),
);

const isMobile = computed(() => /Mobi|Android/i.test(navigator.userAgent));
provide('isMobile', isMobile.value);

const username = ref<string>('Kamu');
provide('userName', username.value);
const showUsernamePrompt = ref<boolean>(false);

onBeforeMount(() => {
  const name = localStorage.getItem('username');
  if (name) {
    username.value = name;
  } else {
    showUsernamePrompt.value = true;
  }
});

const submitName = (e: any) => {
  username.value = e.target?.elements?.username.value;
  showUsernamePrompt.value = false;
  localStorage.setItem('username', username.value);
};

const greetingMessage = computed(() => `Hai, ${username.value}!`);
provide('greetingMessage', greetingMessage);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_Dialog, {
      visible: showUsernamePrompt.value,
      modal: "",
      style: {"width":"80vw","max-width":"450px"}
    }, {
      container: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(store).state.template_messages.welcome_title), 1),
        _createElementVNode("p", {
          innerHTML: _unref(store).state.template_messages.welcome_message
        }, null, 8, _hoisted_2),
        _createElementVNode("form", {
          onSubmit: _withModifiers(submitName, ["prevent"]),
          class: "input-user-name"
        }, _hoisted_6, 40, _hoisted_3)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})